module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-75Bd.5990bf0.woff";